import { portalWebUrl } from '../../../../features/url/baseUrl';
import { ButtonMyPageIndex } from '../../../Button/ButtonMyPageIndex';
import {
  FiClockIcon,
  FiHeartIcon,
  FiLogOutIcon,
  FiUserCheckIcon,
  FiHelpCircleIcon,
  FiMessageCircleIcon,
  FiMailIcon,
} from '../../../Icon';

import styles from './BlockNavigationMyPageIndex.module.scss';

import type { HttpsUrl } from '../../../../types/HttpsUrl';
import type { FC } from 'react';

import { loungeUrl, type AppEnv } from '@/packages/nurse-senka-frontend-sdk';

export type BlockNavigationMyPageIndexProps = {
  appEnv: AppEnv;
  blockNavigationMyPageIndexLinks: {
    bookmarkedArticlesUrl: HttpsUrl;
    profileChangeUrl: string;
    mailMagazineSettingsUrl: string;
    logoutUrl: string;
    helpUrl: HttpsUrl;
    articleViewHistoryUrl?: HttpsUrl;
  };
};

export const BlockNavigationMyPageIndex: FC<
  BlockNavigationMyPageIndexProps
> = ({ appEnv, blockNavigationMyPageIndexLinks }) => (
  <div className={styles.wrap}>
    <div className={styles['wrap-button']}>
      <ButtonMyPageIndex
        icon={FiHeartIcon}
        title="あとでみる"
        readText="あとでみるに登録した記事を一覧"
        link={blockNavigationMyPageIndexLinks.bookmarkedArticlesUrl}
      />
      {blockNavigationMyPageIndexLinks?.articleViewHistoryUrl ? (
        <ButtonMyPageIndex
          icon={FiClockIcon}
          title="閲覧履歴"
          readText="これまで閲覧した記事を一覧"
          link=""
        />
      ) : (
        ''
      )}
      <ButtonMyPageIndex
        icon={FiMessageCircleIcon}
        title="掲示板投稿履歴"
        readText="掲示板へ投稿を一覧"
        link={`${loungeUrl(appEnv)}/my`}
      />
      <ButtonMyPageIndex
        icon={FiUserCheckIcon}
        title="プロフィール変更"
        readText="登録しているプロフィールを変更します"
        link={blockNavigationMyPageIndexLinks.profileChangeUrl}
        useNextLink={true}
      />
      <ButtonMyPageIndex
        icon={FiMailIcon}
        title="メルマガ設定"
        readText="メルマガの配信設定を変更します"
        link={blockNavigationMyPageIndexLinks.mailMagazineSettingsUrl}
        useNextLink={true}
      />
      <ButtonMyPageIndex
        icon={FiHelpCircleIcon}
        title="ヘルプ"
        readText="よくある質問や使い方を確認できます"
        link={`${portalWebUrl(appEnv)}/helps`}
        useNextLink={true}
      />
    </div>
    <div className={styles['wrap-button-under']}>
      <ButtonMyPageIndex
        icon={FiLogOutIcon}
        title="ログアウト"
        link={blockNavigationMyPageIndexLinks.logoutUrl}
        useNextLink={true}
      />
    </div>
  </div>
);
